import * as PIXI from "pixi.js";

export interface ITransformBackup {
    x: number;
    y: number;
    scaleX: number;
    scaleY: number;
    rotation: number;
}

export const TransformBackup = {
    saveTransform(this: PIXI.Container & { scaleX: number, scaleY: number }) {
        TransformBackup.setTransformBackup.call(this, this);
    },
    loadTransform(this: PIXI.Container) {
        if ((this as any)._transformBackup) {
            TransformBackup.copyTransform.call(this, (this as any)._transformBackup);
        }
    },
    copyTransform(this: PIXI.Container, backup: ITransformBackup) {
        this.x = backup.x;
        this.y = backup.y;
        this.scale.x = backup.scaleX;
        this.scale.y = backup.scaleY;
        this.rotation = backup.rotation;
    },
    getTransformBackup(this: PIXI.Container & ITransformBackup, clone?: boolean): ITransformBackup {
        let backup = (this as any)._transformBackup;
        if (!backup) {
            TransformBackup.saveTransform.call(this);
            backup = (this as any)._transformBackup;
        }
        if (clone) {
            return {
                x: backup.x,
                y: backup.y,
                scaleX: backup.scaleX,
                scaleY: backup.scaleY,
                rotation: backup.rotation,
            };
        }
        return backup;
    },
    setTransformBackup(value: ITransformBackup) {
        (this as any)._transformBackup = (this as any)._transformBackup || {};
        (this as any)._transformBackup.x = value.x;
        (this as any)._transformBackup.y = value.y;
        (this as any)._transformBackup.scaleX = value.scaleX;
        (this as any)._transformBackup.scaleY = value.scaleY;
        (this as any)._transformBackup.rotation = value.rotation;
    },
};
